import ShuffleIcon from "@mui/icons-material/Shuffle";
import TabUnselectedIcon from "@mui/icons-material/TabUnselected";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import { Divider, ToggleButton, Tooltip } from "@mui/material";
import { StyledToggleButtonGroup } from "features/WorklistTools/shared/components/styles/styled-components";
import {
  ExternalThawStep,
  SelectionProcess,
} from "features/WorklistTools/shared/interfaces";
import React from "react";
import { ExternalThawInternalAction } from "../state/actions";
import { useExternalThawStateProvider } from "../state/StateProvider";

export const SelectionView = () => {
  const { externalThawInternalState, externalThawDispatch } =
    useExternalThawStateProvider();

  return (
    <React.Fragment>
      <StyledToggleButtonGroup
        value={externalThawInternalState.destSelectionProcess}
        exclusive
        onChange={(e, value) => {
          externalThawDispatch({
            type: ExternalThawInternalAction.SET_DEST_SELECTION_PROCESS,
            payload: {
              destSelectionProcess: value,
            },
          });
        }}
      >
        <ToggleButton
          value={SelectionProcess.Stamp}
          disabled={
            externalThawInternalState.step !==
            ExternalThawStep.SelectIntermediateToDestination
          }
        >
          <Tooltip title="Stamp" placement="right">
            <TabUnselectedIcon style={{ transform: "scaleX(-1)" }} />
          </Tooltip>
        </ToggleButton>
        <ToggleButton
          value={SelectionProcess.RowWise}
          disabled={
            externalThawInternalState.step !==
            ExternalThawStep.SelectIntermediateToDestination
          }
        >
          <Tooltip title="Row" placement="right">
            <ViewColumnIcon style={{ transform: "rotate(90deg)" }} />
          </Tooltip>
        </ToggleButton>
        <ToggleButton
          value={SelectionProcess.ColWise}
          disabled={
            externalThawInternalState.step !==
            ExternalThawStep.SelectIntermediateToDestination
          }
        >
          <Tooltip title="Column" placement="right">
            <ViewColumnIcon />
          </Tooltip>
        </ToggleButton>
      </StyledToggleButtonGroup>
      <Divider flexItem orientation="vertical" sx={{ mx: 0.5, my: 1 }} />
      <div
        style={{ display: "flex", alignItems: "center", marginRight: "5px" }}
      >
        <ToggleButton
          sx={{ border: "none", marginRight: "3px" }}
          value="randomizeWells"
          selected={externalThawInternalState.randomizeWells}
          disabled={
            externalThawInternalState.step !==
            ExternalThawStep.SelectIntermediateToDestination
          }
          onChange={() => {
            externalThawDispatch({
              type: ExternalThawInternalAction.SET_RANDOMIZE_WELLS,
              payload: {
                randomizeWells: !externalThawInternalState.randomizeWells,
              },
            });
          }}
        >
          <Tooltip title="Randomize" placement="right">
            <ShuffleIcon />
          </Tooltip>
        </ToggleButton>
      </div>
    </React.Fragment>
  );
};
